export * from './scene';
export * from './labels';
export * from './toolbar';
export * from './settings';
export * from './encodings';
export * from './inspector';
export * from './search';
export * from './histograms';
export * from './expressions';
export * from './expander';
export * from './timebar';
export * from './collections';
export * from './chat';

export default function rootReducer(state, action) {
    if (action.type === 'falcor-react-redux/update') {
        return action.data;
    }
    return state;
}
